import request from "../../utiles/axios";

/**
 * 查询角色
 * @param {*} data
 * @returns
 */
export function getPage(data) {
  return request({
    url: "/role/page",
    method: "post",
    data: data,
  });
}
/**
 * 查询机构树
 * @param {*} data
 * @returns
 */
export function getDeptTree(data) {
  return request({
    url: "/dept/deptTree",
    method: "post",
    data: data,
  });
}
/**
 * 新增修改角色
 * @param {*} data
 * @returns
 */
export function saveOrUpdate(data) {
  return request({
    url: "/role/saveOrUpdate",
    method: "post",
    data: data,
  });
}
/**
 * 角色启用/禁用切换
 * @param {*} data
 * @returns
 */
export function updateEnableFlag(data) {
  return request({
    url: "/user/updateEnableFlag",
    method: "post",
    data: data,
  });
}
/**
 * 查询角色菜单
 * @param {*} id
 * @returns
 */
export function queryMenuByRole(data) {
  return request({
    url: "/role/queryMenuByRole",
    method: "post",
    data: data,
  });
}
